import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackCustomFieldsActionParams } from '../types';

export const useTrackClickedSaveCustomField = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedSaveCustomField = useCallback(
    (params: TrackCustomFieldsActionParams) => {
      track(`Clicked Save custom field`, params);
    },
    [track],
  );

  return { trackClickedSaveCustomField };
};
